import { useEffect, useState } from "react";
import { Box, Chip, Divider, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { brandColors } from "../../../const/colors";
import { AppPage, AppHeader, AppCard } from "../../../layout/layout";
import { publicRecipeService } from "../../../services/publicRecipe-service";


export default function RecipeDetails() {
    const { id } = useParams();
    const recipeId = Number(id);

    const [recipe, setRecipe] = useState<any | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;

        async function run() {
            setLoading(true);
            try {
                const data = await publicRecipeService.getById(recipeId);
                console.log("DATA", data);
                if (!cancelled) setRecipe(data);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        if (Number.isFinite(recipeId)) run();
        return () => {
            cancelled = true;
        };
    }, [recipeId]);

    if (loading || !recipe) {
        return (
            <AppPage>
                <AppHeader title="Recipe" subtitle="Loading..." />
                <AppCard>
                    <Typography color="text.secondary">Loading...</Typography>
                </AppCard>
            </AppPage>
        );
    }

    return (
        <AppPage>
            <AppHeader title={recipe.title} subtitle={recipe.description ?? ""} />

            <AppCard>
                {recipe.imageUrl && (
                    <Box sx={{ mb: 2 }}>
                        <Box
                            component="img"
                            src={recipe.imageUrl}
                            alt={recipe.title}
                            sx={{
                                width: "100%",
                                maxHeight: 360,
                                objectFit: "cover",
                                borderRadius: 2,
                                display: "block",
                            }}
                        />
                    </Box>
                )}
                {!!recipe.categoryNames?.length && (
                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
                        {recipe.categoryNames.map((c: any) => (
                            <Chip key={c} label={c} sx={{ bgcolor: brandColors.accent, color: brandColors.accentDark }} />
                        ))}
                    </Stack>
                )}

                <Typography variant="h6" sx={{ color: brandColors.accentDark }}>
                    Ingredients
                </Typography>
                <Stack component="ul" sx={{ pl: 3, mt: 1 }}>
                    {recipe.ingredients.map((i: any) => (
                        <Box key={i} component="li">
                            <Typography>{i}</Typography>
                        </Box>
                    ))}
                </Stack>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" sx={{ color: brandColors.accentDark, mb: 1 }}>
                    Instructions
                </Typography>

                <Box
                    sx={{
                        "& img": { maxWidth: "100%" },
                        "& a": { color: brandColors.primary },
                    }}
                    dangerouslySetInnerHTML={{ __html: recipe.instructionsHtml }}
                />
            </AppCard>
        </AppPage>
    );
}
